import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Stats } from './components/Stats';
import { Services } from './components/Services';
import { Process } from './components/Process';
import { Contact } from './components/Contact';
import { AgencyPopup } from './components/AgencyPopup';
export function App() {
  return <div className="min-h-screen bg-slate-50 font-sans" data-id="element-0">
      <Header data-id="element-1" />

      <main data-id="element-2">
        <Hero data-id="element-3" />
        <Stats data-id="element-4" />
        <Services data-id="element-5" />
        <Process data-id="element-6" />
      </main>

      <Contact data-id="element-7" />

      {/* Promotional Popup that appears at 50% scroll */}
      <AgencyPopup data-id="element-8" />
    </div>;
}